<template>
  <nav
    id="myHeader"
    class="navbar sticky-header navbar-expand-lg navbar-light  default-padding myhead"
  >
    <a class="navbar-brand" href="/rssdi-home">
      <img
        src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/logo/logo-rssdi.png"
        class="rssdi-logo"
        alt="rssdi-logo"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarText"
      aria-controls="navbarText"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav mr-auto">
        <!-- Dropdown -->
        <li class="nav-item"></li>
      </ul>
      <ul class="navbar-nav mr-auto mr-left">
       <!-- <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="home(),scrollToTop()">Home</a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="home(),scrollToTop()"
            >Courses</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="about(),scrollToTop()">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="news_media(),scrollToTop()"
            >News & Events</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="contact(),scrollToTop()"
            >Contact</a
          >
        </li>
         <li class="nav-item">
          <a class="nav-link waves-effect waves-light" @click="rssdiMember(),scrollToTop()"
            >RSSDI Member</a
          >
        </li>
      </ul>
      <span class="navbar-text white-text">
        <button class="bts-nav" @click="signup">LOGIN/SIGNUP</button>
      </span>
    </div>
  </nav>
</template>
<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    signup() {
      // this.$router.push({ name: "signup" });
      this.$router.push({ name: "rssdi-login" });
      return;
    },
    login() {
      this.$router.push({ name: "rssdi-login" });
    },
    coursesrssdi() {
      this.$router.push({ name: "course" });
    },
    home() {
      this.$router.push({ name: "rssdi-home" });
    },
        about() {
      this.$router.push({ name: "aboutus" });
    },
    contact() {
      this.$router.push({ name: "contact" });
    },
    rssdiMember() {
      window.open('https://www.rssdi.in/newwebsite/index.php');
    },
     news_media() {
      this.$router.push({ name: "news_media" });
    },
    showsnackbar(msg, color, to) {
      this.$store.dispatch("setSnackbar", {
        showing: true,
        timeout: to,
        color: color,
        text: msg,
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    document.title = "RESEARCH SOCIETY FOR THE STUDY OF DIABETES IN INDIA";

  },
  watch: {},
};
</script>

<style scoped>
.default-padding {
    padding-left: 4.5rem;
    padding-right: 5rem;
} 
.navbar-light .navbar-nav .nav-link {
    color: rgb(0 0 0 / 77%);
}
.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover{
  color: #9E1B20;
  font-weight: bold;
}
</style>
